import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5361023e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护白名单信息")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}白名单`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      "label-width": "150px",
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "所属机构",
            prop: "collectorId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formModel.orgId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.orgId = $event),
              placeholder: "请选择所属机构",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.orgList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.orgId,
                  label: item.orgName,
                  value: item.orgId
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户",
            prop: "collectorId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              style: {
                "width": "100%"
              },
              modelValue: $data.formModel.customerId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.customerId = $event),
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              placeholder: "请输入用户电话号码",
              "remote-method": $options.remoteMethod,
              loading: $data.loading
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickName + item.phone,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "remote-method", "loading"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户类型",
            prop: "carType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formModel.customerType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.customerType = $event),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.customerTypeList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            required: "",
            label: "时间范围",
            prop: "dates"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formModel.dates,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.dates = $event),
              type: "datetimerange",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              "end-placeholder": "截至时间",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              "default-time": $data.def
            }, null, 8, ["modelValue", "default-time"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "原因",
            prop: "reason"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.reason,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.reason = $event),
              type: "textarea",
              placeholder: "请输入加入白名单原因"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"]), _createVNode(_component_el_form_item, {
      style: {}
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: $options.submitForm,
        style: {
          "margin-left": "45%"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("保存 ")]),
        _: 1
      }, 8, ["onClick"])), [[_directive_permission, ['bikeWhiteList_add', 'bikeWhiteList_edit']]]), _createVNode(_component_el_button, {
        onClick: _cache[5] || (_cache[5] = () => {
          this.$router.go(-1);
        })
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}